import { Fab, ListItemButton, ListItemIcon, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, TableSortLabel, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import UnitDataTableToolbar from './unit/UnitDataTableToolbar';
import CloseIcon from '@mui/icons-material/Close';
import CheckIcon from '@mui/icons-material/Check';

function RoleUnitDataTable({ mainData = [], column, pageTitle, handleDeleteUser, setOpenUnitDialogStatus, type, handleListItemClick }) {
  const [data, setData] = useState(mainData);
  const [data2, setData2] = useState(mainData);
  const [order, setOrder] = useState("asc");
  const [orderBy, setOrderBy] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(25);
  const fontSettings = useSelector((state) => state.meeting.fontSettings);

  const tableCellStyle = {
    fontSize: fontSettings?.baseFontSize,
    ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
  };

  const DataTableHead = ({ onRequestSort, customColumnData }) => {
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };

    return (
      <TableHead>
        <TableRow>
          {customColumnData.map(column => (
            <TableCell
              key={column.id}
              align={column.numeric}
              padding={column.disablePadding ? 'none' : 'normal'}
              sx={tableCellStyle}
            >
              <Tooltip
                title="Sırala"
                placement={column.numeric ? 'bottom-end' : 'bottom-start'}
                enterDelay={300}
              >
                <TableSortLabel
                  active={orderBy === column.id}
                  direction={order}
                  onClick={createSortHandler(column.id)}
                  sx={tableCellStyle}
                >
                  {column.label}
                </TableSortLabel>
              </Tooltip>
            </TableCell>
          ))}
        </TableRow>
      </TableHead>
    );
  };

  const listItemStyle = {
    '&:hover .ListItemIcons': { opacity: 1 },
    justifyContent: 'center',
    padding: 0,
    fontSize: fontSettings?.baseFontSize,
    ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
  };

  const fabStyle = {
    width: fontSettings?.avatarSize,
    height: fontSettings?.avatarSize,
    '& .MuiSvgIcon-root': {
      fontSize: `calc(${fontSettings?.avatarSize} * 0.6)`
    }
  };

  const paginationStyle = {
    '& .MuiTablePagination-root': {
      fontSize: fontSettings?.baseFontSize,
      ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
    },
    '& .MuiTablePagination-selectLabel': {
      fontSize: fontSettings?.baseFontSize,
      ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
    },
    '& .MuiTablePagination-displayedRows': {
      fontSize: fontSettings?.baseFontSize,
      ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
    },
    '& .MuiTablePagination-select': {
      fontSize: fontSettings?.baseFontSize,
      ...(fontSettings?.lineHeight && { lineHeight: fontSettings.lineHeight })
    }
  };

  return (
    <Paper className="col-md-12">
      <UnitDataTableToolbar
        pageTitle={pageTitle}
        data2={data2}
        type={"role"}
        setData={setData}
      />
      <div className="flex-auto">
        <div className="table-responsive-material">
          <Table size='small'>
            <DataTableHead
              order={order}
              orderBy={orderBy}
              rowCount={data.length}
              customColumnData={column}
            />
            <TableBody>
              {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map(n => (
                <TableRow hover key={"trO" + n.customId}>
                  {type === "unit" ? (
                    <>
                      <TableCell align="left" padding="normal" sx={tableCellStyle}>{n.inst}</TableCell>
                      <TableCell align="left" padding="none" sx={tableCellStyle}>{n.name}</TableCell>
                      <TableCell align="center" padding="none">
                        <ListItemButton sx={listItemStyle}>
                          <ListItemIcon
                            className={"ListItemIcons"}
                            sx={{
                              position: 'static',
                              transition: 'all 0.2s',

                              minWidth: 'auto'
                            }}
                          >
                            <Fab
                              size="small"
                              color={"primary"}
                              onClick={() => handleListItemClick(n, 3)}
                              key={n.name}
                              sx={{
                                bgcolor: 'grey.300',
                                '&:hover': {
                                  bgcolor: (theme) => theme.palette.primary.main
                                },
                                width: 20,  // özel genişlik
                                height: 20, // özel yükseklik
                                minHeight: 20, // minimum yükseklik
                                '& .MuiSvgIcon-root': { // icon boyutu
                                  fontSize: '1rem'
                                }
                              }}
                            >
                              <CheckIcon />
                            </Fab>
                          </ListItemIcon>
                        </ListItemButton>
                      </TableCell>
                    </>
                  ) : (
                    <>
                      <TableCell align="left" padding="normal" sx={tableCellStyle}>{n.roleInst}</TableCell>
                      <TableCell align="left" padding="none" sx={tableCellStyle}>{n.unitName}</TableCell>
                      <TableCell align="center" padding="none">
                        <ListItemButton sx={listItemStyle}>
                          <ListItemIcon
                            className={"ListItemIcons"}
                            sx={{
                              position: 'static',
                              transition: 'all 0.2s',

                              minWidth: 'auto'
                            }}
                          >
                            <Fab
                              size="small"
                              aria-label="Delete"
                              onClick={() => {
                                handleDeleteUser(n);
                                setOpenUnitDialogStatus(false)
                              }}
                              sx={{
                                bgcolor: 'grey.300',
                                '&:hover': {
                                  bgcolor: (theme) => theme.palette.primary.main
                                },
                                width: 20,  // özel genişlik
                                height: 20, // özel yükseklik
                                minHeight: 20, // minimum yükseklik
                                '& .MuiSvgIcon-root': { // icon boyutu
                                  fontSize: '1rem'
                                }
                              }}
                            >
                              <CloseIcon />
                            </Fab>
                          </ListItemIcon>
                        </ListItemButton>
                      </TableCell>
                    </>
                  )}
                </TableRow>
              ))}
            </TableBody>
            <TableFooter>
              <TableRow>
                <TablePagination
                  count={data.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={(e, page) => setPage(page)}
                  onRowsPerPageChange={(e) => setRowsPerPage(Number(e.target.value))}
                  labelRowsPerPage={"Görüntülenecek Satır"}
                  rowsPerPageOptions={[10, 50, 100, { label: "Tümü", value: -1 }]}
                  showFirstButton
                  showLastButton
                  sx={paginationStyle}
                />
              </TableRow>
            </TableFooter>
          </Table>
        </div>
      </div>
    </Paper>
  );
}

export default RoleUnitDataTable;